import { createAction, props } from '@ngrx/store';
import { ErrorUnion } from '../models/error-message';

export const errorOccurred = createAction('[Error Message] Error Occured', props<{ error: ErrorUnion }>());
